"use client";

import { Box, Flex, Skeleton } from "@chakra-ui/react";
import { useThemeTokens } from "@/lib/theme/tokens";
import {
  PublicListingPageSkeleton,
  PublicListingRowsSkeleton,
  PublicListingToolbarSkeleton,
} from "@/views/shared/public-listing";

export const LocationsPageSkeleton = ({
  hideHero = false,
}: {
  hideHero?: boolean;
}) => {
  const theme = useThemeTokens();

  return (
    <PublicListingPageSkeleton
      hideHero={hideHero}
      toolbar={<PublicListingToolbarSkeleton variant="selectSearch" />}
    >
      <PublicListingRowsSkeleton count={4}>
        {(index, isLast) => (
          <Box
            key={index}
            py={{ base: 5, md: 6 }}
            borderBottomWidth={isLast ? 0 : "1px"}
            borderColor={theme.borderGlass.subtle}
          >
            <Flex
              direction={{ base: "column", lg: "row" }}
              align={{ base: "stretch", lg: "flex-start" }}
              gap={{ base: 4, lg: 8 }}
            >
              <Skeleton
                flexShrink={0}
                w={{ base: "100%", lg: "148px" }}
                maxW={{ base: "220px", lg: "148px" }}
                aspectRatio="16 / 10"
                borderRadius="10px"
              />

              <Flex direction="column" flex={1} minW={0} gap={2}>
                <Skeleton
                  height={{ base: "24px", md: "28px" }}
                  width={{ base: "70%", md: "55%" }}
                  borderRadius="4px"
                />
                <Skeleton height="16px" width="90%" borderRadius="4px" />
                <Skeleton
                  height="16px"
                  width={{ base: "78%", md: "65%" }}
                  borderRadius="4px"
                />
              </Flex>

              <Flex
                flexShrink={0}
                align={{ base: "flex-end", lg: "center" }}
                justify="flex-end"
                minW={{ lg: "100px" }}
                pt={{ lg: 2 }}
              >
                <Skeleton height="14px" width="72px" borderRadius="4px" />
              </Flex>
            </Flex>
          </Box>
        )}
      </PublicListingRowsSkeleton>
    </PublicListingPageSkeleton>
  );
};
